<template>
    <div class="story d-flex justify-content-start mt-5">
        <wrapper>
            <div class="story-container d-flex" :style="{backgroundImage: 'url(' + img + ')'}">
                <div class="story-content d-flex flex-column justify-content-end justify-content-md-center align-items-center align-items-md-start text-center text-md-start pb-5 pb-md-0 px-4 px-md-0">
                    <div class="story-content-title">{{ $t('trimInc') }}</div>
                    <div class="story-content-text" v-html="text"></div>
                    <a href="/about-us" class="btn btn-primary btn-md rounded-pill text-light">{{ $t('read') }}</a>
                </div>
            </div>
        </wrapper>
    </div>
</template>

<script>
    import Wrapper from "@/components/common/wrapper.vue";

    export default {
        name: "story",

        components: {
            wrapper: Wrapper
        },

        props: {
            text: {
                type: String
            },
            img: {
                type: String
            }
        }
    };
</script>